/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkActionLeadResult
 */
export interface InstanceBulkActionLeadResult {
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkActionLeadResult
     */
    lead_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstanceBulkActionLeadResult
     */
    success: boolean;
}

/**
 * Check if a given object implements the InstanceBulkActionLeadResult interface.
 */
export function instanceOfInstanceBulkActionLeadResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "success" in value;

    return isInstance;
}

export function InstanceBulkActionLeadResultFromJSON(json: any): InstanceBulkActionLeadResult {
    return InstanceBulkActionLeadResultFromJSONTyped(json, false);
}

export function InstanceBulkActionLeadResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionLeadResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'success': json['success'],
    };
}

export function InstanceBulkActionLeadResultToJSON(value?: InstanceBulkActionLeadResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'success': value.success,
    };
}

